import { api } from './apiProvider';

export interface CustomerProfileResponse {
  displayName: string;
  primaryEmail: string;
  mobilePhone: string;
  billingAddress: string;
  billingCity: string;
  billingState: string;
  billingZip: string;
  serviceLocations: ServiceLocationDto[];
}

export interface ServiceLocationDto {
  address: string;
  city: string;
  state: string;
  zip: string;
}

export async function getCustomerProfile(): Promise<CustomerProfileResponse> {
  return await api.get('customers/current', { credentials: 'include' }).json<CustomerProfileResponse>();
}
